import { core, usStreet } from "smartystreets-javascript-sdk";
import { LatLong } from "../useSmartyAddress/useSmartyAddress.types";

const { Lookup } = usStreet;

const key = "120285478463721873";

const clientBuilder = new core.ClientBuilder(new core.SharedCredentials(key));
const client = clientBuilder.buildUsStreetApiClient();

const validationError = "error validating address";

function useAddressValidation() {
  const addressQuery = async (
    street: string,
    city: string,
    state: string
  ): Promise<LatLong> => {
    const l = new Lookup();
    l.street = street;
    l.city = city;
    l.state = state;
    l.match = "strict";
    try {
      await client.send(l);
    } catch (e) {
      throw new Error(validationError);
    }
    const candidate = l.result[l.result.length - 1];
    if (candidate === undefined) {
      throw new Error(validationError);
    }
    // Smarty omits coordinates for some matches; a missing value is passed
    // through to the caller unchanged rather than treated as a failed lookup.
    return {
      lat: candidate.metadata.latitude as number,
      long: candidate.metadata.longitude as number,
    };
  };

  return { addressQuery };
}

export default useAddressValidation;
